import { render, staticRenderFns } from "./FormulaireSoumis.vue?vue&type=template&id=bf4fdaa4"
import script from "./FormulaireSoumis.vue?vue&type=script&lang=js"
export * from "./FormulaireSoumis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports